module.exports = __webpack_public_path__ + "media/images/instagram-534d1baabd2aa6c2d98dca1e3cb82811.png";